import { type CurrentUserIguanaObject } from 'Users';
import { statsigClientProvider } from 'StatsigClientProvider';
import { getUserAnalyticsData } from 'EventLogger';

export default async function identifyUser(
    user: CurrentUserIguanaObject,
    options: { skipStatsigUpdate?: boolean } = {},
) {
    if (!user) return;

    // Push attributes to the GTM data layer
    const userAnalyticsData = await getUserAnalyticsData(user);
    window.dataLayer?.push(userAnalyticsData);

    // Update Statsig user
    if (!options.skipStatsigUpdate) {
        statsigClientProvider
            .waitForClient({ caller: 'identifyUser' })
            .then(client => client.updateUserSync(user.asStatsig()));
    }
}
